module.exports = __webpack_public_path__ + "hyperion-v2-static/img/menu_comms_black.c75cfe11.png";